import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Button, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap'
import { navigate } from '@reach/router'
import { connect } from 'react-redux'
import { handleExpiredAuthState } from '../../redux/actions/authActions'
import CandidatesApi from '../../api/CandidatesApi';
import { ApiException, ExpiredSessionException } from '../../api/exceptions'

const api = new CandidatesApi();

const DetailsButton = ({ controlNumber, handleExpiredAuthState }) => {

  const [isLoading, setIsLoading] = useState(false)

  const alert = withReactContent(Swal)

  const handleBlockedStatus = () => {
    setIsLoading(true)
  }

  useEffect(() => {
    isLoading && (
      api.block(controlNumber)
      .then( response =>  navigate(`/admin/documentos/${controlNumber}`))
      .catch( error => {
        if(error instanceof ExpiredSessionException){
          return handleExpiredAuthState();
        }

        alert.fire({
          toast: true,
          title: (error instanceof ApiException) ? error.message : 'Hubo un error al procesar la solicitud. Intente más tarde.',
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          icon: 'error',
          position: 'top-end'
        })
        setIsLoading(false)
      })
    )
      
  }, [isLoading])

  return (
    <OverlayTrigger
      overlay={
        <Tooltip>
         <strong>Ver Documentaci&oacute;n</strong>
        </Tooltip>
      }
    >
      <Button className="mr-1" variant="secondary" onClick={handleBlockedStatus} >
        { isLoading ? <Spinner size="sm" animation="border" variant="light" /> : <i className=" fa fa-eye"></i> }
      </Button>
    </OverlayTrigger>
  )
}

export default connect(null,{ handleExpiredAuthState })(DetailsButton)